import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  Grid,
  TextField,
} from "@mui/material";
import {
  CheckBox as CheckBoxIcon,
  CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon
} from "@mui/icons-material";

import { useState, useMemo, useEffect } from "react";
import { useFetcher } from "react-router-dom";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const PublisherBiddersForm = ({ publisher, bidders, onCancel }) => {
  const fetcher = useFetcher()
  const activeBidderIds = useMemo(() => new Set(bidders.map(b => b.id)), [bidders])

  const allOptions = useMemo(() => {
    const inactiveBidders = (publisher?.bidders ?? []).filter(b => !activeBidderIds.has(b.id));
    return [...bidders, ...inactiveBidders];
  }, [publisher, bidders, activeBidderIds])

  const defaultBidders = useMemo(() => {
    return allOptions.filter(({ id }) => publisher?.bidders?.find(obj => obj.id === id))
  }, [publisher, allOptions])
  const [selectedValues, setSelectedValues] = useState(defaultBidders)

  const handleSubmit = (e) => {
    fetcher.submit(
      { bidder_ids: selectedValues.map(obj => obj.id) },
      { method: "post", fetcherKey: "bidder-submit" }
    )
  }

  useEffect(() => {
    if (fetcher.state === "idle" && fetcher.data) {
      const updateFailed = "errors" in fetcher.data

      if (!updateFailed) {
        onCancel()
      }
    }
  }, [fetcher, onCancel])

  return (
    <Grid container item>
      <Grid item xs={12}>
        <Autocomplete
          multiple
          fullWidth
          disableCloseOnSelect
          options={allOptions}
          getOptionLabel={(option) => option.name}
          value={selectedValues}
          renderOption={(props, option, { selected }) => {
            const { key, ...optionProps } = props;
            return (
              <li key={key} {...optionProps}>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option.name}
                {!option.active && <Chip label="inactive" size="small" color="default" sx={{ ml: 1 }} />}
              </li>
            );
          }}
          onChange={(e, value) => {
            setSelectedValues(value)
          }}
          renderTags={(options, getTagProps, ownerState) => {
            if (ownerState.popupOpen) return [];

            return options.map(({ id: value, name: label }, index) => {
              const { onDelete, key, ...chipProps } = getTagProps({ index });

              if (value === "all") {
                return <Chip key={key} {...chipProps} label={label} sx={{ backgroundColor: "transparent" }} />
              }

              return <Chip key={key} label={label} {...chipProps} onDelete={onDelete} variant="outlined" />
            })
          }}
          renderInput={(params) => (
            <TextField {...params} placeholder="Search bidders" name="bidders" />
          )}
        />
      </Grid>
      <Grid item xs={12}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            float: "right",
            mt: 2
          }}
        >
          <Button variant="contained" size="small" sx={{ mr: 1 }} onClick={handleSubmit}>Save</Button>
          <Button size="small" onClick={onCancel}>Cancel</Button>
        </Box>
      </Grid>
    </Grid>
  );
}

export default PublisherBiddersForm;
